import {FormBuilderAnswerableMultiSelect, FormBuilderQuestion} from "@/types";
import {useState} from "react";

interface Props {
    question: FormBuilderQuestion,
    hasError: boolean
}

function setArrayData(question, setData, value, selectedOption) {
    setData(question.id, (value.includes(selectedOption) ? value.filter((d) => d != selectedOption) : [...value, selectedOption]))
}

export default function AnswerMultiSelect<T extends { answerable: FormBuilderAnswerableMultiSelect }>({
                                                                                                          question,
                                                                                                          data,
                                                                                                          setData,
                                                                                                          hasError,
                                                                                                          settings
                                                                                                      }: Props) {

    // check if the default is null and convert it to a string because React doesn't like null
    let value: string[] = [];
    if (typeof data[question.id] == 'string') {
        try {
            value = JSON.parse(data[question.id]);
        } catch {
            value = [];
        }
    } else {
        value = data[question.id] ?? []
    }
    // const dropdownValue = (question.answerable.options.includes(value)) ? value : '_OTHER_';
    const optionCount = question.answerable.options.length + (question.answerable.allow_other_answer ? 1 : 0);


    return (
        <div className="relative mt-1">
            <div className="flex flex-wrap -mb-2 [&>:last-child]:mr-0">
                {question.answerable.options.map((option) => {
                    return selectButton(option, value, setArrayData, setData, question, settings)
                })}
                {(question.answerable.allow_other_answer ? selectButton('_OTHER_', value, setArrayData, setData, question, settings) : <></>)}
            </div>
            {otherAnswer(question, data, setData, setArrayData, value, hasError, settings)}
        </div>
    );

}

function otherAnswer(question, data, setData, setArrayData, value, hasError, settings) {
    // We store a temporary value for the other text field
    const currentValue = value.filter((d) => !question.answerable.options.includes(d) && d !== '_OTHER_')

    const [other, setOther] = useState(currentValue && currentValue.length > 0 ? currentValue[0] : '');

    // This function updates the main data form
    // each time the text changes, we need to remove the previous text
    // Otherwise we end up with 'a, ab, abc' etc in the list of selected options
    // We do this by filtering out any values that aren't options for the question and then adding the new value in
    function updateMainDataArray(v) {
        const existingSelectedOptions = data[question.id].filter((e) => question.answerable.options.includes(e))
        setArrayData(question, setData, [...existingSelectedOptions, '_OTHER_'], v);
        return setOther(v);
    }

    if (question.answerable.allow_other_answer && value.includes('_OTHER_')) {
        return (<div className="mt-2">
            <input type={question.answerable.type} value={other}

                   minLength={"min_length" in question.answerable ? question.answerable.min_length : 0}
                   maxLength={"max_length" in question.answerable ? question.answerable.max_length : 524_288}
                   required={"is_required" in question.answerable ? question.answerable.is_required : false}
                   className={` rounded shadow-sm block w-full sm:text-sm disabled:opacity-50 disabled:cursor-not-allowed ${hasError ? 'border-red-300 pr-10 text-red-900 placeholder-red-300 focus:border-red-500 focus:outline-none focus:ring-red-500' : `border-gray-100 focus:border-[${settings.primaryColour}] focus:ring-[${settings.primaryColour}] `}`}
                   placeholder={"placeholder_text" in question.answerable ? question.answerable.placeholder_text : ''}
                   aria-describedby={`${question.id}-description`}
                   id={`${question.id}-target`}
                   onChange={(e) => updateMainDataArray(e.target.value)}/>
        </div>)
    } else {
        return <></>
    }
}

function selectButton(option, selectedOptions, setArrayData, setData, question, settings) {
    return (<button key={option}
                    type="button"
                    onClick={(e) => {
                        const maxSelectedOptions = question.answerable.max_selected;
                        console.log(maxSelectedOptions, 'test')
                        if (maxSelectedOptions == 1 && !selectedOptions.includes(option)) {
                            // If max selectable is 1 then we just overwrite the existing option
                            setArrayData(question, setData, [], option)
                            return;
                        } else if (maxSelectedOptions && selectedOptions.length >= maxSelectedOptions && !selectedOptions.includes(option)) {
                            return;
                        }
                        setArrayData(question, setData, selectedOptions.filter((o) => o !== null), option)
                    }}
                    className={`flex-grow text-sm mr-2 mb-2 disabled:opacity-50 disabled:cursor-not-allowed ${selectedOptions.includes(option)
                        ? `border-[${settings?.primaryColour}] focus:ring-[${settings?.primaryColour}] focus:border-[${settings?.primaryColour}] bg-[${settings?.secondaryColour}] text-gray-600 `
                        : `border-gray-100 bg-gray-50 text-gray-600 hover:bg-gray-50 focus:ring-[${settings?.primaryColour}] focus:border-[${settings.primaryColour}] `} relative rounded border overflow-hidden inline-flex items-center  px-4 py-2 focus:z-10 focus:outline-none focus:ring-1`}>
        {selectedOptions.includes(option) ?
            //checked checkbox style check box to use primary colour and round the corners
            <input type={"checkbox"} style={{color: settings?.primaryColour}} className={`mr-2 rounded focus:ring-[${settings?.primaryColour}] border-[${settings?.primaryColour}] accent-[${settings?.primaryColour}]`} checked={true} readOnly={true}/>
            : <input type={"checkbox"} className={`mr-2 rounded focus:ring-[${settings?.primaryColour}] border-[${settings?.primaryColour}] accent-[${settings?.primaryColour}]`} checked={false} readOnly={true}/>}
        {option == '_OTHER_' ? 'Other' : option}
    </button>);
}
